import React from "react";
import { PlusIcon } from "./icons/PlusIcon";
import { Dots } from "./icons/Dots";
import { Info } from "./icons/Info";

export const Titlebar = ({ toggle, toggleOptions, setShowInfo }) => {
  return (
    <div className="title-bar">
      <div>
        <h1>Kikiriki online alarm clock</h1>
        <p style={{ margin: 0 }}>
          Made with ❤️ by{" "}
          <a
            target="_blank"
            rel="noreferrer"
            style={{ color: "var(--greenish)" }}
            href="https://bakedbird.com"
          >
            bakedbird
          </a>
        </p>
        <p style={{ margin: 0 }}>
          <a
            target="_blank"
            rel="noreferrer"
            style={{ color: "var(--redish)" }}
            href="https://www.patreon.com/bakedbird"
          >
            <b>Support me on Patreon</b>
          </a>
        </p>
      </div>
      <div>
        <button className="btn btn-circle m" onClick={toggle}>
          <PlusIcon fill="var(--light)" />
        </button>
        <button className="btn btn-circle m" onClick={toggleOptions}>
          <Dots fill="var(--light)" />
        </button>
        <button
          className="btn btn-circle m"
          onClick={() => setShowInfo(() => true)}
        >
          <Info fill="var(--light)" />
        </button>
      </div>
    </div>
  );
};
